//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.OpravaMetadatOvereniDlg.ts           </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2020                            </Copyright>
//    <Created>     2020-01-27                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class OpravaMetadatOvereniDlg extends GContentBase<Wfl.ListAC.WflListBaseAC>
    {
        model: Pod.Interface.GOpravaMetadatOvereniZpravyDto;

        onContentReady() {
            var that = this;
            Wfl.ListAC.WflListBaseAC.InitList(this);
            this.topActions.push(this.CreateActionAktualizovatOvereni());
            this.topActions.push(this.CreateActionDetailDokSpis());
            this.topActions.push(this.CreateActionZobrazInfoOvereni_OLD());
            this.topActions.push(this.CreateActionZobrazInfoOvereni_NEW());
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
            this.SetData();
            Gordic.Wfl.ListAC.WflListBaseAC.SetActionEnabled(this, Pod.Globals.ActionsName.opravaElPodani, this.model.IsDuvodKOprave!)
            if (this.model.IsDuvodKOprave == false)  this.showFlash("jres:23900174"); //RC 23900174 : K aktualizaci oveření není důvod.           
        }

        SetData() {

            const that = this;
            let _iconTypPodepsaniMsg_OLD = Gordic.Pod.GPodFunction.GetGIconDefinitionTypPodpisu(this.model.TypPodepsaniMsg_OLD);
            let _iconTypPodepsaniMsg_NEW = Gordic.Pod.GPodFunction.GetGIconDefinitionTypPodpisu(this.model.TypPodepsaniMsg_NEW);
            let _iconTypOvereniMsg_OLD = Gordic.Pod.GPodFunction.GetGIconDefinitionVysledekOvereni(this.model.TypOvereniMsg_OLD);

            let _iconZpusobDoruceni = this.model.ZpusobDoruceniIcon;
            const form = new Gordic.Forms
                .Form({ name: "frmOpravy", layoutDescriptor: "L1M1S1" });
                form.addSection();
            form.addPrefab(Wfl.Prefabs.GIdentifikatorDokumnetuSpisu({
                fieldOpt: {
                    name: "Ixp",
                    disabled: true
                }
            }))
                .addSection()
                .addRow("jres:23900083").addField("gstringbox", { name: "Vec", disabled: true }) //RC 23900083 : Věc
                .addRow(this.LabelZnacka).addField("gstringbox", { name: "Znacka", disabled: true }) //RC 23900159 : Značka
                .addRow("jres:31950114").addField("gstringbox", { name: "VecPodrobne", disabled: true }) //RC 31950114 : Věc podrobně
                .addRow("jres:23900010").addField("gstringbox", {
                    name: "ZpusobDoruceniTooltip", disabled: true,
                    states: [
                        { icon: _iconZpusobDoruceni.Ikona, customClass: "g-state-important", tooltip: _iconZpusobDoruceni.Tooltip }
                    ]
                })

                .addRow("jres:23900160") //RC 23900160 : Podepsání
                .addField("gstringbox", "w-6", {
                    name: "PodepsaniMsgInfo_OLD",
                    disabled: true,
                    states: [{ icon: _iconTypPodepsaniMsg_OLD.icon, customClass: "g-state-important", tooltip: _iconTypPodepsaniMsg_OLD.tooltip }]
                })

                .addRow("jres:23900161") //RC 23900161 : Ověření
                .addField("gstringbox", "w-6", {
                    name: "OvereniMsgInfo_OLD", disabled: true,
                    states: [
                        { icon: _iconTypOvereniMsg_OLD.icon, customClass: "g-state-important", tooltip: _iconTypOvereniMsg_OLD.tooltip}
                    ]
                });

            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", form);
            this.findFields().gfield("model", "apply", this.model);
            this.findFields("ZpusobDoruceniTooltip").gfield("setValue", this.model.ZpusobDoruceniIcon.Tooltip);
            this.SetGridPriloh()
        }

        CreateGrid(): void
        {
            var that = this;
            var gf = Gordic.Wfl.ListAC.WflListBaseAC.GetGridFormat();
            gf.addIconColumn(this.DelegateTypZarazenJako());
            gf.addTextColumn({ name: "JmenoSouboru", caption: "jres:31950196", width: Gordic.Wfl.ListPrefabs.GridSirkaNazev })  //RC 31950196 : Jméno souboru
            gf.addIconColumn(this.DelegateTypSouboru());
            gf.addIconColumn(this.DelegateTypPodepsani());
            gf.addIconColumn(this.DelegateStavOvereni_OLD());
            gf.addIconColumn(this.DelegateIsRozpor());

            var OpenInfo = new GAction({     //obsluzna akce, ktera se spousti dbl clickem nad radkem
                name: "gridRowSelectedAct",
                run: function (ev, ctx) {
                    that.ZobrazOvereni_NEW();
                }
            });

            this.gridOptions = {};
            this.gridOptions.searchColumns = ["JmenoSouboru", "ixb"];
            this.gridOptions.defaultAction = OpenInfo;
            var grid = Gordic.Wfl.ListAC.WflListBaseAC.CreateGridBase(this, gf);
            this.mainGrid = grid;
            Gordic.Wfl.ListAC.WflListBaseAC.AfterCreateGrid(this);
        }

        SetGridPriloh()
        {
            this.CreateGrid();
            var view = new Gordic.Data.View(this.model.Prilohy, { key: this.IDPrimaryKeyGridu }); 
            this.mainGrid.ggrid("setData", view);
        }

        DelegateTypZarazenJako(): GGridColumn<any> {
            return {
                caption: "jres:31950198", //RC 31950198 : Zařazen jako
                name: "typZarazenJakoIcon",
                field: "ZarazenJako",
                iconTemplate: function (row: any)
                {
                    return Gordic.Pod.GPodFunction.GetGIconDefinitionTypZarazeniElSouboru(row.ZarazenJako);
                }
            }
        }

        DelegateTypSouboru(): GGridColumn<any> {
            return {
                caption: "jres:31950199", //RC 31950199 : Typ souboru
                name: "typSouboruIcon",
                field: "typSouboru",
                iconTemplate: function (row: any)
                {
                    return { icon: Gordic.Utils.File.getFileTypeIconClass(row.typSouboru || " "), tooltip: row.typSouboru }; // TODO;
                }
            }
        }

        DelegateTypPodepsani(): GGridColumn<any> {
            return {
                caption: "jres:23900162", //RC 23900162 : Typ podpisu
                name: "DelegateTypPodepsani",
                field: "TypPodepsani",
                iconTemplate: function (row: any) {
                    return Gordic.Pod.GPodFunction.GetGIconDefinitionTypPodpisu(row.TypPodepsani);
                }
            }
        }

        DelegateStavOvereni_OLD(): GGridColumn<any> {
            return {
                caption: "jres:23900169", //RC 23900169 : Původní ověření
                name: "DelegateStavOvereni_OLD",
                field: "StavOvereni_OLD",
                iconTemplate: function (row: any)
                {
                    return Gordic.Pod.GPodFunction.GetGIconDefinitionStavOvereni(row.StavOvereni_OLD);
                }
            }
        }

        DelegateIsRozpor(): GGridColumn<any> {
            return {
                caption: "jres:31950197", //RC 31950197 : Informace
                name: "DelegateIsRozpor",
                field: "IsRozpor",
                iconTemplate: function (row: any)
                {
                    let ico: IconTemplate = {};
                    ico.icon = "";
                    ico.tooltip = "";
                    if (row.IsRozpor)
                    {
                        ico.icon = Gordic.Gin.Icons.StavEnum.kUpozorneni;
                        ico.tooltip = "jres:23900168"; //RC 23900168 : V ověření je problém
                    }
                    return ico;
                }
            }
        }

        CreateActionAktualizovatOvereni(): GAction {
            var that = this;
            var action = new GAction({
                name: Pod.Globals.ActionsName.opravaElPodani,
                icon: Gordic.Gin.Icons.ActionEnum.opravit,
                caption: "jres:23900173", //RC 23900173 : Aktualizovat
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                    that.call("Aktualizovat", { Ixp: that.model.Ixp })
                        .done(function (ret) {
                            Gordic.Wfl.ListAC.WflListBaseAC.ResolveResultInfoContentu(that);
                            Gordic.Wfl.AC.WflBaseAC.ShowInfoPromise(that, "jres:23900175").done(function (ret) { that.close(true) });
                        })
                        .always(function () {
                            that.endOperation();
                        });
                }
            });
            return action;
        }

        CreateActionZobrazInfoOvereni_OLD(): GAction
        {
            var that = this;
            var action = new GAction({
                name: Pod.Globals.ActionsName.zobrazHistoriiOvereni,
                icon: Gordic.Gin.Icons.ActionEnum.informace,
                caption: "jres:23900176", //RC 23900176 : Zobrazit historii ověření el. podpisů
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                    that.ZobrazOvereni_OLD();
                }
            });
            return action;
        }

        ZobrazOvereni_OLD()
        {
            var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(this) as Pod.Interface.GOpravaMetadatOvereniSouboruDto;
            if (rowData)
            {
                // 21.07.2020 - TFeik
                // Odstranění zpomalovače.
                if (rowData.ixb) {
                    Wfl.Dialogs.HistorieOvereniDlg(this, { Ixb: rowData.ixb });
                }
            }
        }

        CreateActionZobrazInfoOvereni_NEW(): GAction {
            var that = this;
            var action = new GAction({
                name: Pod.Globals.ActionsName.zobrazAktualniOvereni,
                icon: Gordic.Gin.Icons.ActionEnum.informace,
                caption: "jres:23900201", //RC 23900201 : Zobrazit aktuální ověření el. podpisů
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                    that.ZobrazOvereni_NEW();
                }
            });
            return action;
        }

        ZobrazOvereni_NEW() {
            var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(this) as Pod.Interface.GOpravaMetadatOvereniSouboruDto;
            if (rowData) {
                // 21.07.2020 - TFeik
                // Odstranění zpomalovače.
                if (rowData.IDGenerated) {
                    Wfl.Dialogs.GOveritPodpisContextDlg(this, { ParamGroup: "ElPodani", ParamName: rowData.IDGenerated, Filename: rowData.jmenoSouboru });
                }
            }
        }

        CreateActionDetailDokSpis(): GAction
        {
            var that = this;
            var l_action = Wfl.PreActions.OtevriDetailDokumentuSpisu({
                inputData: function () {
                    return {
                        parentContent: that,
                        opt: {
                            DetailDto: { ixp: that.model.Ixp },
                            grid: undefined
                        }
                    };
                },
                always: function (retVal) {
                    if (retVal) {
                        //reagovat na zmenu    
                    }
                }
            });
            var action = new GAction( l_action );
            action.groupName = Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite;
            return action;
        }
    }
};
